import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import store from './store'
import HttpRequest from '@/utils/httpRequest'
import '@/assets/iconfont/iconfont.css' // iconfont矢量图
import '@/assets/global.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueCookie from 'vue-cookie'
import { packageStatus, isOrNot, ellipsis, versionType, status } from '@/filters'
import 'babel-polyfill'
import md5 from 'js-md5'

Vue.prototype.$http = HttpRequest
Vue.prototype.$md5 = md5
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(VueCookie)
Vue.filter('packageStatus', packageStatus)
Vue.filter('isOrNot', isOrNot)
Vue.filter('ellipsis', ellipsis)

Vue.filter('versionType', versionType)
Vue.filter('status', status)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
